module.exports = __webpack_public_path__ + "static/media/  (66).b12ccb91.jpg";